import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {authoritiesApi} from '../api';

export const authoritiesKeys = {
  all: () => ['authorities'] as const
};

export function useAuthoritiesQuery(options?: {enabled?: boolean}) {
  const client = useApiClient();
  return useQuery({
    queryKey: authoritiesKeys.all(),
    queryFn: () => authoritiesApi.fetchAuthorities(client),
    enabled: options?.enabled ?? true,
    select: response => response.data,
    staleTime: 60 * 60 * 1000
  });
}
